function getEnvironmentVariable(name: string, defaultValue: any): string | undefined;
function getEnvironmentVariable(name: "VITE_BASE_URL", defaultValue: any): string;
function getEnvironmentVariable(name: "VITE_REST_API_BASE_URL", defaultValue: any): string;

function getEnvironmentVariable(name: string, defaultValue: string): string | undefined {
  const value = import.meta.env[name];

  // development
  if (import.meta.env.MODE === "development") {
    return value;
  }

  // production
  return value || defaultValue;
}

export const baseURL = getEnvironmentVariable("VITE_BASE_URL", "https://www.webgazer.io");
export const capBaseURL = getEnvironmentVariable("VITE_CAP_BASE_URL", "https://cap.unius.sh");
export const capIsEnabled = getEnvironmentVariable("VITE_CAP_IS_ENABLED", "true");
export const capSiteKey = getEnvironmentVariable("VITE_CAP_SITE_KEY", "480df740af");
export const chatwootWebsiteToken = getEnvironmentVariable("VITE_CHATWOOT_WEBSITE_TOKEN", "V9maqG8EZsh2ddi5VNwjzcaB");
export const posthogAPIKey = getEnvironmentVariable("VITE_POSTHOG_API_KEY", "phc_jn5KQ52gcJbkEEstFZQMLxlK01VILTRg89NvI7O3D56");
export const restAPIBaseURL = getEnvironmentVariable("VITE_REST_API_BASE_URL", "https://api.webgazer.io");
export const sentryDSN = getEnvironmentVariable("VITE_SENTRY_DSN", "");
export const sentryEnvironment = getEnvironmentVariable("VITE_SENTRY_ENVIRONMENT", "");
export const slackClientID = getEnvironmentVariable("VITE_SLACK_CLIENT_ID", "3913219156.261382399426");
export const tagsEnvironment = getEnvironmentVariable("VITE_TAGS_ENVIRONMENT", "production");
